// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
  height: 80px;
}
header .logo {
  height: 50px;
  margin-left: 60px;
  margin-right: 60px;
}
@media only screen and (max-width: 600px) {
  header .logo {
    margin-left: 20px;
    margin-right: 20px;
  }
}
header .flex-row {
  max-height: 100%;
  display: flex;
  flex-direction: row;
}
header .flex-row .flex-row-left {
  width: -moz-available;
  width: -webkit-fill-available;
  height: 80px;
  display: flex;
  align-items: center;
}
header .flex-row .flex-row-right {
  height: 80px;
  margin-right: 60px;
  text-align: right;
  display: flex;
  align-items: center;
}
@media only screen and (max-width: 600px) {
  header .flex-row .flex-row-right {
    margin-right: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/styles.less"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;AAFA;EAIQ,YAAA;EACA,iBAAA;EACA,kBAAA;AACR;AAEY;EAAA;IACI,iBAAA;IACA,kBAAA;EACd;AACF;AAbA;EAkBQ,gBAAA;EACA,aAAA;EACA,mBAAA;AAFR;AAlBA;EAuBY,qBAAA;EACA,6BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAFZ;AAzBA;EA+BY,YAAA;EACA,kBAAA;EAOA,iBAAA;EACA,aAAA;EACA,mBAAA;AATZ;AAEgB;EAAA;IACI,kBAAA;EAClB;AACF","sourcesContent":["header {\n    height: 80px;\n \n    .logo {\n        height: 50px; \n        margin-left: 60px;\n        margin-right: 60px;\n\n        @media only screen {\n            @media (max-width: 600px) {\n                margin-left: 20px;\n                margin-right: 20px;\n\n            }\n        }\n    }\n \n    .flex-row {\n        max-height: 100%;\n        display: flex;\n        flex-direction: row;\n        \n        .flex-row-left {\n            width: -moz-available; \n            width: -webkit-fill-available;\n            height: 80px;\n            display: flex;\n            align-items: center;\n        }\n        \n        .flex-row-right {\n            height: 80px;\n            margin-right: 60px;\n            @media only screen {\n                @media (max-width: 600px) { \n                    margin-right: 20px;\n\n                }\n            }\n            text-align: right;\n            display: flex;\n            align-items: center;\n        }\n    } \n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
